const WEATHER_API_URL = "https://api.open-meteo.com/v1/forecast";

const AARAU_WEATHER = {
  latitude: 47.39254,
  longitude: 8.04422,
  timezone: "Europe/Zurich",
};

interface OpenMeteoWeatherResponse {
  current?: {
    temperature_2m?: number;
    weather_code?: number;
  };
}

export interface GreetingWeather {
  temperature?: number;
  weatherLabelKey: string;
}

export const getWeatherLabelKey = (weatherCode?: number) => {
  if (weatherCode === 0) return "dashboard.weather.sunny";
  if ([1, 2].includes(weatherCode ?? -1)) return "dashboard.weather.partlyCloudy";
  if (weatherCode === 3) return "dashboard.weather.cloudy";
  if ([45, 48].includes(weatherCode ?? -1)) return "dashboard.weather.fog";
  if ([51, 53, 55, 56, 57, 61, 63, 65, 66, 67, 80, 81, 82].includes(weatherCode ?? -1)) {
    return "dashboard.weather.rain";
  }
  if ([71, 73, 75, 77, 85, 86].includes(weatherCode ?? -1)) return "dashboard.weather.snow";
  if ([95, 96, 99].includes(weatherCode ?? -1)) return "dashboard.weather.storm";
  return "dashboard.weather.unknown";
};

export const fetchGreetingWeather = async (
  signal?: AbortSignal,
): Promise<GreetingWeather> => {
  const params = new URLSearchParams({
    latitude: String(AARAU_WEATHER.latitude),
    longitude: String(AARAU_WEATHER.longitude),
    timezone: AARAU_WEATHER.timezone,
    current: "temperature_2m,weather_code",
  });

  const response = await fetch(`${WEATHER_API_URL}?${params.toString()}`, { signal });

  if (!response.ok) {
    throw new Error("Weather request failed");
  }

  const data = (await response.json()) as OpenMeteoWeatherResponse;

  return {
    temperature:
      typeof data.current?.temperature_2m === "number"
        ? Math.round(data.current.temperature_2m)
        : undefined,
    weatherLabelKey: getWeatherLabelKey(data.current?.weather_code),
  };
};
